/* ═══════════════════════════════════════════════════════════════════════════
   HỘP GÓP Ý TRÊN TRANG LUẬN GIẢI — chiến dịch 107.

   Phần nhìn thấy dựng bằng Liquid: khung hộp ở `sections/pheu-107-luan-giai.liquid`, từng
   câu hỏi ở `snippets/pheu-107-cau-hoi.liquid`. Đọc và gom câu trả lời do
   `MS107.gomCauHoi()` lo — dùng chung với trang khảo sát.

   File này lo phần riêng của hộp: mở/đóng, giam phím Tab, gửi, rồi rẽ nhánh theo điểm.
   Không tự gọi mạng — nối backend thì sửa `assets/pheu-107-gui.js`.
   🗓️ Xoá cùng cả bộ `pheu-107-*` khi chiến dịch đóng.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var goc = document.querySelector('[data-plg]');
  var nen = document.querySelector('[data-lg7-nen]');
  /* Bám LỚP `.lg7-neo`, không bám `[data-lg7-mo]`: từ nay thẻ mời góp ý cuối hai màn con cũng
     mang thuộc tính đó, nên selector cũ có ngày trả về nhầm nút và `batDau()` sẽ đi bỏ `hidden`
     của một phần tử không phải nút góc. */
  var neo = document.querySelector('.lg7-neo[data-lg7-mo]');
  if (!goc || !nen || !neo || !window.MS107) return;

  var hop    = nen.querySelector('[data-lg7-hop]');
  var form   = nen.querySelector('[data-lg7-form]');
  var oXong  = nen.querySelector('[data-lg7-xong]');
  var nutGui = nen.querySelector('[data-lg7-gui]');
  var oLoi   = nen.querySelector('[data-lg7-loi]');
  var nutTiep= nen.querySelector('[data-lg7-tiep]');
  var oND    = document.querySelector('[data-plg-noi-dung]');

  var NGUONG = parseInt(goc.getAttribute('data-nguong-diem'), 10) || 4;
  var KHOA_XONG = 'ms107_da_gop_y';

  /* Chữ báo lỗi để ngay đây chứ không thành ô cài đặt: đây là câu chỉ hiện khi máy hỏng hoặc
     khách bỏ trống, người kinh doanh không có lý do phải sửa, mà thêm ô cài đặt là thêm chỗ
     có thể bị bỏ trống. */
  var CHU = {
    thieu:    'This one is needed.',
    thieuDiem:'Pick a number first — that is the part we really need.',
    khongGui: 'We could not save that just now. Reply straight to our email and we will read it there.'
  };

  MS107.noiCauHoi(form);

  /* ── Mở / đóng ───────────────────────────────────────────────────────────────
     Nhớ phần tử đang được chọn TRƯỚC khi mở, để lúc đóng trả con trỏ về đúng chỗ cũ. Thiếu
     bước này thì người đi bằng bàn phím bị ném về đầu trang sau mỗi lần đóng hộp. */
  var truocDo = null;
  var cuonCu = '';

  function dangMo() { return !nen.hasAttribute('hidden'); }

  function mo() {
    if (dangMo()) return;
    truocDo = document.activeElement;
    nen.removeAttribute('hidden');
    nen.setAttribute('aria-hidden', 'false');

    /* Khoá cuộn nền. Giữ lại giá trị cũ thay vì gán '' lúc đóng — theme có thể đang tự đặt
       `overflow` cho việc khác (ngăn giỏ chẳng hạn) và xoá trắng là phá của người ta. */
    cuonCu = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    /* Đưa con trỏ vào đúng thứ khách cần chạm tiếp. Đã gửi rồi thì hộp đang ở màn cảm ơn —
       lúc đó nút sang trang bán mới là chỗ đúng, mà nút đó có thể đang ẩn (chưa khai đích),
       nên rơi về nút đóng. Dội thẳng vào ô điểm ở màn cảm ơn là đưa người ta về một biểu
       mẫu đã bị giấu. */
    var dau;
    if (oXong && !oXong.hasAttribute('hidden')) {
      dau = (nutTiep && !nutTiep.hasAttribute('hidden'))
        ? nutTiep
        : nen.querySelector('[data-lg7-dong]');
    } else {
      dau = form.querySelector('[data-q7-diem]:checked') || form.querySelector('[data-q7-diem]');
    }
    if (dau) { try { dau.focus(); } catch (e) {} }
  }

  function dong() {
    if (!dangMo()) return;
    nen.setAttribute('hidden', '');
    nen.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = cuonCu;
    if (truocDo) { try { truocDo.focus(); } catch (e) {} }
  }

  /* Nghe ở tầng `document`, không gắn vào từng nút. Lối vào thứ hai nằm TRONG khung bài đọc,
     mà `moMan()` thay sạch `innerHTML` mỗi lần đổi màn — nút gắn sự kiện trực tiếp thì sống
     đúng một màn rồi thành nút chết, im lặng, không lỗi nào báo. Uỷ nhiệm thì mọi lối vào
     mang `data-lg7-mo` đều chạy, kể cả lối sinh sau. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var cua = e.target.closest('[data-lg7-mo]');
    if (!cua) return;
    e.preventDefault();
    mo();
  });

  var dsDong = nen.querySelectorAll('[data-lg7-dong]');
  for (var i = 0; i < dsDong.length; i++) dsDong[i].addEventListener('click', dong);

  /* Bấm ra nền thì đóng — nhưng CHỈ khi cú bấm bắt đầu từ chính lớp nền. Bấm vào trong hộp
     rồi thả chuột ra ngoài (kéo chọn chữ trong ô góp ý là ra đúng ca đó) mà đóng luôn là
     nuốt mất thứ khách vừa gõ. */
  nen.addEventListener('mousedown', function (e) { nen.__tuNen = (e.target === nen); });
  nen.addEventListener('click', function (e) {
    if (e.target === nen && nen.__tuNen) dong();
    nen.__tuNen = false;
  });

  document.addEventListener('keydown', function (e) {
    if (!dangMo()) return;
    if (e.key === 'Escape') { dong(); return; }
    if (e.key !== 'Tab') return;

    /* Giam phím Tab trong hộp. Không giam thì Tab đi tiếp vào bài đọc phía sau — người dùng
       bàn phím "rơi" ra khỏi hộp đang mở mà không biết, và không có đường quay lại. */
    var duoc = hop.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input:not([type="hidden"]), select, [tabindex]:not([tabindex="-1"])');
    var thay = [];
    for (var k = 0; k < duoc.length; k++) {
      var el = duoc[k];
      if (el.offsetParent !== null || el === document.activeElement) thay.push(el);
    }
    if (!thay.length) return;
    var dauT = thay[0], cuoi = thay[thay.length - 1];
    if (e.shiftKey && document.activeElement === dauT) { e.preventDefault(); cuoi.focus(); }
    else if (!e.shiftKey && document.activeElement === cuoi) { e.preventDefault(); dauT.focus(); }
  });

  /* ── Đích sang trang bán ─────────────────────────────────────────────────────
     CHÉP từ khối chốt cuối bài đọc thay vì tự ghép lại. Khối đó do `veChot()` dựng và đã nối
     sẵn `?axis=<trục yếu>` lấy từ dữ liệu phiên. Tự ghép lần hai là đẻ ra hai đường dẫn có
     thể lệch nhau — mà lệch thì trang bên kia mở bằng câu chào của người khác.
     Không tìm thấy khối chốt (bài đọc chưa dựng xong) thì rơi về ô cài đặt. */
  function dichBan() {
    var a = document.querySelector('.plg__chot a[href]');
    if (a) {
      var h = a.getAttribute('href') || '';
      if (h.charAt(0) === '/' && h.charAt(1) !== '/') return h;
    }
    var d = (goc.getAttribute('data-dich-offer') || '').trim();
    if (d.charAt(0) === '/' && d.charAt(1) !== '/') return d;
    return '';
  }

  function dichThap() {
    var d = (goc.getAttribute('data-dich-gop-y-thap') || '').trim();
    if (d.charAt(0) === '/' && d.charAt(1) !== '/') return d;
    return '';
  }

  /* ── Gửi rồi mới đi ──────────────────────────────────────────────────────────
     Điều hướng NGAY sau khi gọi gửi là giết luôn lời gọi đang bay — trình duyệt huỷ mọi
     request dở dang khi rời trang. Đợi gửi xong rồi mới đi, nhưng có trần 2 giây: mạng kém
     không được phép giữ khách đứng đó mãi. Mất một sự kiện còn hơn mất một khách. */
  function doiRoiDi(loiHua, dich) {
    var daDi = false;
    function di() {
      if (daDi) return;
      daDi = true;
      window.location.assign(dich);
    }
    setTimeout(di, 2000);
    loiHua.then(di, di);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var gom = MS107.gomCauHoi(form);

    /* Không có câu chấm điểm nào được điền thì dừng lại. Đây là câu duy nhất bắt buộc thật:
       thiếu nó thì không rẽ nhánh được, mà đoán bừa một nhánh còn tệ hơn hỏi lại. */
    if (!gom.diem) {
      var oDiem = form.querySelector('[data-loai="cau_diem"]');
      if (oDiem) MS107.baoThieu([oDiem], CHU.thieuDiem);
      if (gom.thieu.length) MS107.baoThieu(gom.thieu, CHU.thieu);
      oLoi.textContent = CHU.thieuDiem;
      oLoi.removeAttribute('hidden');
      return;
    }
    if (gom.thieu.length) {
      MS107.baoThieu(gom.thieu, CHU.thieu);
      oLoi.textContent = CHU.thieu;
      oLoi.removeAttribute('hidden');
      return;
    }

    oLoi.setAttribute('hidden', '');
    nutGui.disabled = true;
    nutGui.setAttribute('aria-busy', 'true');

    var loiHua = MS107.gui('feedback_done', {
      diem: gom.diem, nguong: NGUONG, tra_loi: gom.tra_loi
    });

    try { sessionStorage.setItem('ms107_diem', String(gom.diem)); } catch (e2) {}
    try { localStorage.setItem(KHOA_XONG, '1'); } catch (e3) {}
    neo.setAttribute('data-xong', '');

    /* ── Rẽ nhánh ──────────────────────────────────────────────────────────────
       DƯỚI ngưỡng: sang trang hỏi cần cải thiện gì, mang theo mã phiên trên mảnh neo để
       trang bên kia biết đang nghe ai nói.
       TỪ ngưỡng trở lên: KHÔNG tự đẩy đi đâu cả. Hiện lời cảm ơn cùng một nút để khách tự
       bấm. Người vừa nói "bản đọc đúng với tôi" mà bị ném thẳng sang trang bán thì câu cảm
       ơn thành cái bẫy — và họ nhớ điều đó lâu hơn nhớ bản đọc. */
    if (gom.diem < NGUONG) {
      var dThap = dichThap();
      if (dThap) {
        var ma = MS107.phien();
        doiRoiDi(loiHua, dThap + (ma ? '#s=' + encodeURIComponent(ma) : ''));
        return;
      }
      /* Chưa khai trang đó thì ở lại, vẫn cảm ơn tử tế. Không dẫn khách vào hư không. */
    }

    loiHua['catch'](function () { return false; }).then(function (xong) {
      nutGui.disabled = false;
      nutGui.removeAttribute('aria-busy');

      /* Gửi hỏng thì NÓI THẬT. Hiện "cảm ơn" trong khi chưa chữ nào về tới mình là lời nói
         dối tiện tay — và nó làm hỏng đúng thứ chiến dịch này đi xin. */
      if (!xong) {
        oLoi.textContent = CHU.khongGui;
        oLoi.removeAttribute('hidden');
      }

      form.setAttribute('hidden', '');
      oXong.removeAttribute('hidden');

      var d = dichBan();
      if (d && gom.diem >= NGUONG) {
        nutTiep.setAttribute('href', d);
        nutTiep.removeAttribute('hidden');
        try { nutTiep.focus(); } catch (e4) {}
      }
    });
  });

  if (nutTiep) {
    nutTiep.addEventListener('click', function () {
      MS107.bao('upsell_clicked', { tu: 'popup-gop-y' });
    });
  }

  /* ── Hiện nút khi bài đọc đã dựng ────────────────────────────────────────────
     Bài đọc do `pheu-107-luan-giai.js` vẽ sau một lời gọi mạng, nên lúc file này chạy thì
     chưa có gì. Theo dõi đúng thời điểm khối nội dung bỏ `hidden`.

     Vì sao không hiện nút ngay từ đầu: mời khách chấm điểm một bản đọc chưa hiện ra — hoặc
     đang báo lỗi — là hỏi về thứ họ chưa thấy. Điểm thu được khi đó là điểm rác. */
  function batDau() {
    if (!neo.hasAttribute('hidden')) return;
    neo.removeAttribute('hidden');
    /* Bắn kèm BẬC MỞ KHOÁ, và chỉ bắn MỘT LẦN mỗi lượt ghé.

       Vì sao kèm bậc: bài đọc dựng ra cả khi phiên còn `free` — lúc đó khách mới thấy phần
       mồi rồi gặp ổ khoá, tức CHƯA thật sự nhận được quà. Bắn trần trụi `gift_opened` thì
       flow gửi thư đọc thành "đã nhận quà rồi" và bỏ qua thư tặng quà, đúng với người cần
       nó nhất. Có `access` thì bên gửi thư lọc được: chỉ coi là đã nhận khi khác `free`.

       Vì sao chặn trùng: sự kiện này bắn mỗi lần bài đọc dựng, tức mỗi lần tải trang. Đo
       17/09: một người mở thư ba lần ra ba dòng `gift_opened` trong bảy phút. Không sai,
       nhưng nó thổi phồng mọi phép đếm. Chặn theo bộ nhớ PHIÊN, không phải bộ nhớ lâu dài —
       hôm sau quay lại thì vẫn nên đếm là một lượt ghé mới. */
    var bac = (oND && oND.getAttribute('data-access')) || 'free';
    var daBan = false;
    try { daBan = !!sessionStorage.getItem('ms107_da_bao_qua'); } catch (e) {}
    if (!daBan) {
      try { sessionStorage.setItem('ms107_da_bao_qua', '1'); } catch (e) {}
      MS107.bao('gift_opened', { access: bac, mo_khoa: bac !== 'free' });
    }

    /* Nút thứ hai, đặt ngay cuối bài đọc. Nút dính chân trang lo người bỏ giữa chừng; nút
       này lo người đọc hết — tới đáy rồi thì chỗ tự nhiên để góp ý là ngay đó, không phải
       một viên thuốc ở góc màn hình. */
    try {
      var chot = oND.querySelector('.plg__chot');
      var them = document.createElement('button');
      them.type = 'button';
      them.className = 'plg__nut lg7-cuoi';
      them.textContent = neo.querySelector('.lg7-neo-chu').textContent;
      them.addEventListener('click', mo);
      var boc = document.createElement('p');
      boc.style.textAlign = 'center';
      boc.style.marginBlockStart = '28px';
      boc.appendChild(them);
      if (chot && chot.parentNode) chot.parentNode.insertBefore(boc, chot);
      else oND.appendChild(boc);
    } catch (e) {}
  }

  /* ── CHẾ ĐỘ XEM THỬ `?demo=1` ────────────────────────────────────────────────
     CHỈ để gửi người khác duyệt giao diện. Trang này cần mã phiên thật mới dựng được bài
     đọc, mà chưa có mã thì nút góp ý không hiện — tức người được gửi link sẽ không thấy
     đúng cái cần duyệt.

     Đổ vào một đoạn giữ chỗ có DÁN NHÃN RÕ là bản xem thử. Không dán nhãn thì người duyệt
     tưởng đó là bài đọc thật và góp ý về một thứ không tồn tại.

     🗓️ GỠ KHỐI NÀY trước khi phát thư cho 107 khách. Nó chỉ chạy khi địa chỉ có `?demo=1`
     nên không cản đường ai, nhưng để lại là để một cửa cho người lạ thấy chữ giả trên trang
     mình đang tặng thật.
     ───────────────────────────────────────────────────────────────────────── */
  function xemThu() {
    if (!/[?&]demo=1(&|$)/.test(window.location.search || '')) return false;
    if (!oND) return false;

    var doan = 'This is placeholder text standing in for the real reading, so the '
             + 'feedback box below can be reviewed. The real page is written per person '
             + 'from their quiz answers.';
    var ra = '<div style="margin:0 0 26px;padding:12px 14px;border-radius:12px;'
           + 'border:1px dashed rgb(142 53 96 / .5);color:#8E3560;font-size:13px">'
           + 'PREVIEW MODE — the text below is placeholder, not a real reading.</div>'
           + '<h2 class="plg__muc">1 &middot; WHO YOU ARE</h2>';
    for (var i = 0; i < 5; i++) ra += '<p class="plg__doan">' + doan + '</p>';
    ra += '<div class="plg__chot"><p>Your reading names the thread that frayed first. '
        + 'The 28-day reset is the part that mends it.</p>'
        + '<a class="plg__nut" href="' + (goc.getAttribute('data-dich-offer') || '#')
        + '">See what comes next</a></div>';

    var ds = document.querySelectorAll('[data-plg-thieu-ma],[data-plg-dang-tai],[data-plg-loi]');
    for (var k = 0; k < ds.length; k++) ds[k].setAttribute('hidden', '');
    oND.innerHTML = ra;
    oND.removeAttribute('hidden');
    return true;
  }

  if (oND) {
    xemThu();
    if (!oND.hasAttribute('hidden')) batDau();
    else {
      var doi = new MutationObserver(function () {
        if (!oND.hasAttribute('hidden')) { doi.disconnect(); batDau(); }
      });
      doi.observe(oND, { attributes: true, attributeFilter: ['hidden'] });
    }
  }

  /* Đã góp ý ở lượt trước thì làm nút nhạt đi. Không ẩn hẳn: người ta có quyền nói thêm. */
  try { if (localStorage.getItem(KHOA_XONG)) neo.setAttribute('data-xong', ''); } catch (e) {}

  /* ── `?gopy=1` — mở thẳng hộp 7 câu ──────────────────────────────────────────
     Link để gửi cho người cần trả lời BỘ CÂU HỎI mà không phải đi tìm nút. Khác `?demo=1`:
     `demo` dựng một bài đọc giả để có bối cảnh rồi vẫn bắt bấm nút, còn cờ này bung hộp ngay.

     Trang phía sau để CHẠY BÌNH THƯỜNG — không ẩn đi. Đóng hộp ra là gặp đúng bản luận giải
     của mình, y như khi tự bấm nút góc; bản đầu dẹp nền bằng CSS thì Esc một cái là rơi vào
     trang trắng trơn, người nhận tưởng hỏng.

     Chỉ gọi `mo()`, KHÔNG tự bỏ `hidden` của nút góc: `batDau()` mới là chỗ lo việc đó, và nó
     thoát sớm khi nút đã hiện — chạm vào trước là nó bỏ qua luôn cả việc bắn `gift_opened` lẫn
     việc chèn nút cuối bài. Bài đọc dựng xong thì mọi thứ diễn ra đúng như một lượt ghé thường.

     Hộp mở NGAY, không đợi bài đọc: đợi thì link mất tác dụng đúng lúc mạng chậm hoặc bản đọc
     không dựng được — mà đó lại là lúc người ta cần nói với mình nhất. Bài đọc cứ tải sau nền
     mờ, tới khi khách đóng hộp là đã có sẵn.

     Định danh: hộp gửi kèm `email` và `session` lấy từ `#email=` / `#s=` hoặc bộ nhớ trình
     duyệt. Link trần vẫn nhận được góp ý nhưng không gắn được với ai. */
  if (/[?&]gopy=1(&|$)/.test(window.location.search || '')) mo();
})();
